import React, { createContext, useContext, useMemo } from 'react';

export interface PageIncludeStackEntry {
	contentId: string;
	title: string;
}

export interface PageIncludeContextValue {
	includeStack: readonly PageIncludeStackEntry[];
}

export const PageIncludeContext: React.Context<PageIncludeContextValue> =
	createContext<PageIncludeContextValue>({
		includeStack: [],
	});

export interface PageIncludeContextProviderProps {
	children: React.ReactNode;
	contentId: string;
	title: string;
}

export const PageIncludeContextProvider = ({
	children,
	contentId,
	title,
}: PageIncludeContextProviderProps): React.JSX.Element => {
	const { includeStack } = useContext(PageIncludeContext);

	const nextStack = useMemo(
		() => [...includeStack, { contentId, title }],
		[includeStack, contentId, title],
	);

	const value = useMemo(() => ({ includeStack: nextStack }), [nextStack]);

	return <PageIncludeContext.Provider value={value}>{children}</PageIncludeContext.Provider>;
};
